import { apiFetch } from '@/shared/auth/runtimeAuth';
import {
  API_BASE_URL,
  fetchShowcaseData,
  getCurrentShowcaseProjectId,
  getShowcaseBlockIdFromUrl,
} from '@/shared/api/showcaseApi';

export type UploadedFile = {
  url: string;
  mime_type: string;
};

export const SHOWCASE_DOCUMENT_ACCEPT = '.pdf,.docx,.xlsx';
export const SHOWCASE_RESULT_ACCEPT = `${SHOWCASE_DOCUMENT_ACCEPT},.png,.jpg,.jpeg,.webp`;

export async function uploadShowcaseFile(
  file: File,
  kind: 'image' | 'document',
): Promise<UploadedFile> {
  const form = new FormData();
  form.append('file', file);
  let projectId = getCurrentShowcaseProjectId();
  if (!projectId) {
    const blockId = getShowcaseBlockIdFromUrl();
    if (blockId) {
      projectId = (await fetchShowcaseData(blockId)).project_id;
    }
  }
  const query = projectId
    ? `?project_id=${encodeURIComponent(projectId)}&product=showcase&showcase_block_id=${encodeURIComponent(getShowcaseBlockIdFromUrl() || '')}`
    : '';
  const response = await apiFetch(`${API_BASE_URL}/messages/upload/${kind}${query}`, {
    method: 'POST',
    body: form,
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null) as { detail?: string } | null;
    throw new Error(payload?.detail || 'Не удалось загрузить файл');
  }
  return response.json() as Promise<UploadedFile>;
}
